const value = {
    projects: 'Проекты',
    systems: 'Системы',
    settings: 'Настройки',
    analytics: 'Аналитика',
    logout: 'Выйти',
    learning: 'Знания',
    leaderBoards: 'Рейтинг',
  };

export default value;
